import { compose, createStore, applyMiddleware } from "redux";
import createRootReducer from "./rootReducer";
import history from "../history";
import { thunk } from "redux-thunk";
export { history };

export default function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(),
    preloadedState,
    compose(applyMiddleware(thunk)),
  );

  return store;
}
